import base from '@/http/url_base';

export default {
  OBJECTIF: base.API_RH + '/employe-objectifs',
  UPDATE_STATUT: base.API_RH + '/employe-objectifs/update-statut',
  NOTE: base.API_RH + '/employe-objectif-notes',
};
